import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'

// 全局 css
import './style/index.less'
// vant的css
import 'vant/lib/index.css'
import './assets/iccon/iconfont.css'
// 加载动态设置 REM 基准值
import 'amfe-flexible'
import 'vue-easytable/libs/theme-default/index.css'
import VueEasytable from 'vue-easytable'
// import Vconsole from 'vconsole'
Vue.use(VueEasytable)
Vue.use(Vant)
// const vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
